import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
      const sessionId = params.get("session_id");
      if (!sessionId) {
        navigate("/login");
        return;
      }
      try {
        await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        await refresh();
        window.history.replaceState(null, "", "/courses");
        navigate("/courses");
      } catch (e) {
        navigate("/login");
      }
    };
    processSession();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-3 text-slate-500">
        <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
        Signing you in…
      </div>
    </div>
  );
}
